<template>
  <div>
    <b-overlay :show="showOverlay" rounded="sm">
      <ValidationObserver ref="searchForm" slim>
        <b-form @submit.prevent="submit" class="w-100">
          <b-row>
            <b-col md="3">
              <b-form-group
                  :label="$gettext('Activity type')"
                  label-class="chr-label"
                  label-for="car_type"
                >
                <b-form-select
                  class="mv-form-control form-control"
                  id="car_type"
                  size="sm"
                  v-model="selectedParams.product_tag"
                  :options="productOptions"
                >
                <template v-slot:first>
                  <b-form-select-option :value="null">-- <translate>any</translate> --</b-form-select-option>
                </template>
                </b-form-select>
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group
                  :label="$gettext('Area')"
                  label-class="chr-label"
                  label-for="transfer_from"
                >
                <b-form-select
                  class="mv-form-control form-control"
                  id="transfer_from"
                  size="sm"
                  v-model="selectedParams.place"
                  :options="areasOptions"
                >
                <template v-slot:first>
                  <b-form-select-option :value="null">-- <translate>any</translate> --</b-form-select-option>
                </template>
                </b-form-select>
              </b-form-group>
            </b-col>
            <b-col md="3">
              <ValidationProvider
                name="Date"
                :rules="{ required: true }"
                vid="checkIn"
                v-slot="vContext"
                >
                <b-form-group
                  label="Data"
                  label-class="font-weight-bold my-0 py-0"
                  label-for="checkIn">
                  <b-form-select
                    class="mv-form-control form-control"
                    id="transfer_from"
                    size="sm"
                    v-model="selectedParams.date"
                    :options="dateOptions"
                    @change="onCheckInChange"
                    :state="getValidationState(vContext)"
                  >
                    <b-form-select-option :value="null">-- selecteaza --</b-form-select-option>
                  </b-form-select>
                  <b-form-invalid-feedback id="checkin-live-feedback">{{ vContext.errors[0] }}</b-form-invalid-feedback>
                </b-form-group>
              </ValidationProvider>
            </b-col>
            <b-col md="3">
              <b-form-group
                  :label="$gettext('Flexibility')"
                  label-class="chr-label"
                  label-for="flexibility"
                >
                <b-form-select
                  class="mv-form-control form-control"
                  id="flexibility"
                  size="sm"
                  v-model="selectedParams.date_flexibility"
                  :options="dateFlexibilityOptions"
                >
                </b-form-select>
              </b-form-group>
            </b-col>
            <b-col md="2" v-show="false">
              <ValidationProvider
                name="Days"
                :rules="{ required: true }"
                vid="nights"
                v-slot="vContext">
                <b-form-group
                  :label="$gettext('Days')"
                  label-class="chr-label"
                  label-for="nights">
                  <b-input
                    v-model="nights"
                    size="sm"
                    aria-describedby="nights-live-feedback" />
                  <b-form-invalid-feedback id="nights-live-feedback">{{ vContext.errors[0] }}</b-form-invalid-feedback>
                </b-form-group>
              </ValidationProvider>
            </b-col>
            <b-col md="3" v-show="false">
              <ValidationProvider
                name="Return date"
                label-class="chr-label"
                label-for="checkOut"
                :rules="{ required: true }"
                vid="checkOut"
                v-slot="vContext"
                >
                <b-form-group
                  :label="$gettext('Return Date')"
                  label-class="chr-label"
                  label-for="checkOut"
                  >
                  <DatePicker
                    v-model="selectedCheckOut"
                    id="checkOut"
                    class="k-btn"
                    :state="getValidationState(vContext)"
                    size="sm"
                    lang="en"
                    :today-label="$gettext('today')"
                    :selected-date-label="$gettext('selected date')"
                    placeholder="zz/ll/aaaa"
                    aria-describedby="checkout-live-feedback"
                    @change="onCheckOutChange"
                  ></DatePicker>
                  <b-form-invalid-feedback id="checkout-live-feedback">{{ vContext.errors[0] }}</b-form-invalid-feedback>
                </b-form-group>
              </ValidationProvider>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="4">
              <b-form-group
                  :label="$gettext('Keyword')"
                  label-class="chr-label"
                  label-for="keyword"
                >
                  <b-form-input id="keyword" name="keyword" v-model="selectedParams.keyword" size="sm"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group
              :label="$gettext('Passengers')"
              label-class="chr-label"
              label-for="passengers">
                <room
                  v-model="room"
                  :id="room"
                  :showDelete="false"
                  :showAdd = "false" />
              </b-form-group>
            </b-col>
            <b-col class="pt-3">
              <b-row class="d-flex align-items-center justify-content-end mt-2">
                <b-col sm="8">
                  <b-button variant="warning" class="btn-block float-right" type="submit"><b-icon icon="search" /><span class="ml-2" v-translate>Search</span></b-button>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </b-form>
      </ValidationObserver>
    </b-overlay>
  </div>
</template>

<script>
import moment from 'moment'

import formMixin from '@/app/private/shared/mixins/search_forms'
import validation from 'b2b-common/mixins/validation'
import toast from 'b2b-common/mixins/toast'

import DatePicker from 'b2b-common/components/datepicker'
import Room from '@/app/private/shared/components/search_form_room.vue'

import {
  getDestinationPoints,
  getProductTags,
  getAllocDates
} from 'b2b-common/services/api/other'

export default {
  name: 'searchForm',
  components: { DatePicker, Room },
  mixins: [formMixin, validation, toast],
  props: ['params'],
  data () {
    return {
      selectedParams: {
        adults: 2,
        child_ages: [],
        contracts: [],
        done: false,
        date: null,
        date_flexibility: 0,
        return_date: null,
        place: null,
        keyword: ''
      },
      defaultNights: 7,
      areasList: [],
      productTypesList: [],
      datesList: [],
      room: {}
    }
  },
  methods: {
    async getDestinationPointsList () {
      this.resetList('areas')
      this.addRequest('areas')
      try {
        const res = await getDestinationPoints({
          product_type: 51
        })
        this.areasList = res
      } finally { this.removeRequest('areas') }
      return this.areasList
    },
    async getProductTagsList () {
      this.resetList('products')
      this.addRequest('products')
      try {
        const res = await getProductTags({
          product_type: 51
        })
        this.productTypesList = res
      } finally { this.removeRequest('products') }
      return this.areasList
    },
    async getDatesList () {
      this.resetList('dates')
      this.addRequest('dates')
      try {
        const res = await getAllocDates({})
        this.datesList = res.map(el => el.date)
      } finally { this.removeRequest('dates') }
      return this.datesList
    },
    updateCheckIn (date) {
      this.selectedCheckIn = date
    },
    updateCheckOut (date) {
      this.selectedCheckOut = date
    },
    onCheckOutChange (val) {
      const mVal = moment(val)
      // check to see if it is a valid value
      // it it's invalid don't do anything
      if (!mVal.isValid()) return
      let mCheckIn = moment(this.selectedCheckIn)
      if (!mCheckIn.isValid() || mCheckIn.isAfter(mVal)) {
        // modify check in according to no of nights
        if (!mCheckIn.isValid()) mCheckIn = moment(mVal).hour(15).minute(0).second(0)
        const currentNights = moment(mCheckIn).startOf('day').diff(moment(mVal).startOf('day'), 'days')
        this.selectedCheckIn = mCheckIn.subtract(currentNights + this.defaultNights, 'days').toDate()
      }
    },
    onCheckInChange (val) {
      const mVal = moment(val)
      // check to see if it is a valid value
      // it it's invalid don't do anything
      if (!mVal.isValid()) return
      let mCheckOut = moment(this.selectedCheckOut)
      // modify check out according to default no of nights
      if (!mCheckOut.isValid()) mCheckOut = moment(mVal).hour(11).minute(0).second(0)
      const currentNights = moment(mVal).startOf('day').diff(moment(mCheckOut).startOf('day'), 'days')
      this.selectedCheckOut = mCheckOut.add(currentNights + this.defaultNights, 'days').toDate()
    },
    submit () {
      this.$refs.searchForm.validate().then(success => {
        if (!success) {
          this.addToast({
            title: this.$gettext('Invalid form'),
            message: this.$gettext('Please fill in all required fields' + '!'),
            variant: 'danger'
          })
        } else {
          this.selectedParams.adults = this.room.adults
          this.selectedParams.child_ages = this.room.ages
          this.selectedParams.return_date = this.selectedParams.date
          this.onSubmit()
        }
      })
    }
  },
  computed: {
    dateFlexibilityOptions () {
      return [
        { value: 0, text: this.$gettext('exact date') },
        { value: 3, text: this.$gettext('+/- 3 days') },
        { value: 5, text: this.$gettext('+/- 5 days') },
        { value: 10, text: this.$gettext('+/- 10 days') }
      ]
    },
    selectedCheckIn: {
      get () {
        const mVal = moment(this.selectedParams.date, 'DD-MM-YYYY')
        if (mVal.isValid()) return mVal.toDate()
        return null
      },
      set (val) {
        this.selectedParams.date = val ? moment(val).format('DD-MM-YYYY') : null
      }
    },
    selectedCheckOut: {
      get () {
        const mVal = moment(this.selectedParams.return_date, 'DD-MM-YYYY')
        if (mVal.isValid()) return mVal.toDate()
        return null
      },
      set (val) {
        this.selectedParams.return_date = val ? moment(val).format('DD-MM-YYYY') : null
      }
    },
    nights: {
      get () {
        if (this.selectedParams.checkIn && this.selectedParams.checkOut) {
          return moment(this.selectedCheckOut).startOf('day').diff(moment(this.selectedCheckIn).startOf('day'), 'days')
        }
        return this.defaultNights
      },
      set (val) {
        if (val === null || val === undefined || val === '' || val < 0) return
        this.defaultNights = val
        if (this.selectedCheckIn) {
          const start = moment(this.selectedCheckIn)
          const end = (this.selectedCheckOut) ? moment(this.selectedCheckOut) : moment(start).set('hour', 11).set('minute', 0)
          const eodStart = moment(start).startOf('day')
          const eodEnd = moment(end).startOf('day')
          const currentNights = eodEnd.diff(eodStart, 'days')
          this.selectedCheckOut = end.add(val - currentNights, 'days').toDate()
        }
      }
    },
    areasOptions () {
      return this.areasList.map(el => ({ value: el.id, text: el.name }))
    },
    productOptions () {
      return this.productTypesList.map(el => ({ value: el.id, text: el.label }))
    },
    dateOptions () {
      return this.datesList.map(el => {
        const text = moment(el, 'YYYY-MM-DD').format('DD-MM-YYYY')
        return { value: text, text }
      })
    },
    showOverlay () { return this.activeRequests.length > 0 }
  },
  async created () {
    this.selectedParams = { ...this.params }
    this.room = {
      adults: this.selectedParams.adults,
      ages: this.selectedParams.child_ages
    }
    this.getDestinationPointsList()
    this.getProductTagsList()
    await this.getDatesList()
    if (this.selectedParams.date) {
      const mom = moment(this.selectedParams.date, 'DD-MM-YYYY').format('YYYY-MM-DD')
      if (!this.datesList.find(el => el === mom)) this.selectedParams.date = null
    }
  }
}
</script>
